<template>
  <div class="slide-page page6" @touchmove="handleTouchMove">
    <NavBarM @jump="jump" ref="navbar"></NavBarM>
    <!-- 联系方式 -->
    <div class="slide-content page6-content" ref="content">
      <div class="page6-inner">
        <img class="page6-title" src="../../assets/img/label-Ct.png" alt="" />
        <div class="phoneBox">
          <h3>
            <img
              style="width: 0.34rem"
              src="../../assets/img/p-mark1.png"
              alt=""
            />联系人：
          </h3>

          <p>
            <span>hr </span>
            <span>17722696719/18038067025、0755-84711199</span>
          </p>

          <h3>
            <img
              style="width: 0.3rem"
              src="../../assets/img/e-mark2.png"
              alt=""
            />简历投递邮箱：
          </h3>

          <p>
            HR@rihaocpa.com、syd@rihaocpa.com、zsm@rihaocpa.com、wkk@rihaocpa.com
          </p>

          <h3>
            <img
              style="width: 0.25rem"
              src="../../assets/img/o-mark3.png"
              alt=""
            />公司地址：
          </h3>

          <p>深圳：广东省深圳市南山区高新中一道9号软件大厦9楼909号</p>
          <p>北京：北京市西城区复兴门外大街A2号1幢5层518室</p>
          <p>广西：广西南宁市良庆区庆歌路富雅国际商务大厦B座3021号</p>
        </div>
        <div class="qr-row">
          <img class="qr-img1" src="../../assets/img/app/QR-img1.png" alt="" />
          <img class="qr-img2" src="../../assets/img/app/QR-img2.png" alt="" />
        </div>
        <div class="qr-extra-wrap">
          <img class="qr-extra" src="../../assets/img/app/QR-img3.png" alt="" />
          <div class="qr-caption">微信扫码添加咨询人事</div>
        </div>
      </div>
    </div>
    <div class="page6-footer">
      <FooterM></FooterM>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import NavBarM from "../../components/NavBarM.vue";
import FooterM from "../../components/FooterM.vue";
BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
    NavBarM,
  },
  data() {
    return {
      bScroll: null,
    };
  },
  methods: {
    jump(index) {
      this.$emit("jump", index);
    },
    handleTouchMove() {
      this.$refs.navbar.hidden();
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 2rem;
  margin-right: 0.1rem;
}
/deep/ .el-collapse-item__arrow {
  display: none;
}
.slide-page.page6 {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 11.2rem;
}
.page6-content {
  flex: 1;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
  box-sizing: border-box;
}
.page6-content > .page6-inner {
  min-height: 0 !important;
  height: auto !important;
  padding-bottom: 0.15rem;
}
.page6-title {
  height: 1.3rem;
  width: 4.6rem;
  margin: 0.25rem 0 0.15rem;
}
.phoneBox {
  text-align: left;
  margin: 0 1rem 0.35rem 1rem;
  font-size: 0.4rem;
  color: rgb(10, 150, 221);
  p {
    text-indent: unset;
    font-size: 0.35rem;
    color: black;
    margin-bottom: 0.08rem;
    line-height: 1.35;
  }
  h3 {
    margin: 0.12rem 0 0.04rem;
  }
}
span {
}
.qr-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 0.15rem;
  margin-bottom: 0.12rem;
}
.qr-row img {
  margin-right: 0;
}
.qr-img1 {
  width: 4rem;
}
.qr-img2 {
  width: 3.6rem;
}
.qr-extra {
  display: block;
  width: 3.6rem;
  margin: 0 auto;
}
.qr-extra-wrap {
  margin: 0 auto;
  text-align: center;
  padding-bottom: 0.1rem;
  margin-top: 15px;
}
.qr-caption {
  margin-top: 0.06rem;
  font-size: 0.32rem !important;
  line-height: 0.42rem !important;
  font-weight: 700 !important;
  color: #555 !important;
  text-align: center !important;
  text-indent: 0 !important;
  letter-spacing: 0.02rem;
}
.page6-footer {
  margin-top: auto;
  flex-shrink: 0;
  width: 100%;
  text-align: center;
  z-index: 2;
  padding: 0.1rem 0 calc(0.12rem + env(safe-area-inset-bottom));
}
</style>

<style lang="less">
/* 覆盖 mobile.vue 全局裁切，避免联系方式页底部文字被挡 */
.slide-vertical .slide-vertical-wrapper .slide-page.page6 {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 1.8rem - env(safe-area-inset-bottom));
  overflow: hidden;
}
.slide-page.page6 .slide-content.page6-content {
  height: auto !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible !important;
}
.slide-page.page6 .slide-content.page6-content > div {
  min-height: 0 !important;
}
.slide-page.page6 .page6-footer .footer {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
</style>
